import { createFileRoute } from "@tanstack/react-router";
import { useConnectionOutcome } from "../../../features/instagram/outcome";
import { validateOutcomeSearch } from "../../../features/instagram/outcomeSearch";
import { OnboardingInstagram } from "../../../features/onboarding/OnboardingInstagram";

export const Route = createFileRoute("/_app/onboarding/instagram")({
  validateSearch: validateOutcomeSearch,
  component: function Instagram() {
    return <OnboardingInstagram outcome={useConnectionOutcome(Route.useSearch())} />;
  },
});
